import Configuration from "./configuration";

class Functions {
    static getActualPath(pathname) {
        let actualPage = pathname.split("/")[1];
        actualPage = actualPage === "" ? "home" : actualPage;
        
        return Configuration.pages.indexOf(actualPage) !== -1 && actualPage;
    }
}

export default Functions;